import { ADD_CORPORATE_VENDOR, BASE_URL, CORPORATE_VENDOR, DELETE_CORPORATE_VENDOR, EDIT_CORPORATE_VENDOR} from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";


export async function getCorporateVendors(params: string = ""): Promise<any[]> {
  const response = await axios.get(BASE_URL + CORPORATE_VENDOR + params);
  return response.data;
}
export async function addCorporateVendors(data: any) {
  const response = await axios.post(BASE_URL + ADD_CORPORATE_VENDOR, data);
  return response.data;
}

export async function editCorporateVendors(data: any,id:string) {
  const response = await axios.patch(BASE_URL + EDIT_CORPORATE_VENDOR+"?id="+id, data);
  return response.data;
}

export async function deleteCorporateVendors(id: string) {
  const response = await axios.delete(BASE_URL + DELETE_CORPORATE_VENDOR + "/" + id);
  return response.data;
}

export const CorporateVendorsCells: HeadCell[] = [

  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "T_name",
  },
  {
    id: "nameAr",
    numeric: false,
    disablePadding: false,
    label: "T_name_Ar",
  },
 
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
